import {
  store,
} from '../../store/store';

const getUserLocationFromStore = () => store.state.user.location;

export {
  getUserLocationFromStore,
};
